import { render, staticRenderFns } from "./CustomerServiceRedeemed.vue?vue&type=template&id=088c3765&scoped=true&"
import script from "./CustomerServiceRedeemed.vue?vue&type=script&lang=js&"
export * from "./CustomerServiceRedeemed.vue?vue&type=script&lang=js&"
import style0 from "./CustomerServiceRedeemed.vue?vue&type=style&index=0&id=088c3765&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088c3765",
  null
  
)

export default component.exports